"use strict";
exports.__esModule = true;
exports.WorkflowStatus = exports.IssuerStatus = exports.CredentialStatus = void 0;
var CredentialStatus;
(function (CredentialStatus) {
    CredentialStatus["VALID"] = "valid";
    CredentialStatus["EXPIRED"] = "expired";
    CredentialStatus["REVOKED"] = "revoked";
})(CredentialStatus = exports.CredentialStatus || (exports.CredentialStatus = {}));
var IssuerStatus;
(function (IssuerStatus) {
    IssuerStatus["VERIFIED"] = "verified";
    IssuerStatus["UNVERIFIED"] = "unverified";
})(IssuerStatus = exports.IssuerStatus || (exports.IssuerStatus = {}));
var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["NEW"] = "New";
    WorkflowStatus["APPROVED"] = "Approved";
    WorkflowStatus["DECLINED"] = "Declined";
    WorkflowStatus["PENDING"] = "Pending";
    WorkflowStatus["DONE"] = "Done";
    WorkflowStatus["ARCHIVED"] = "Archived";
})(WorkflowStatus = exports.WorkflowStatus || (exports.WorkflowStatus = {}));
